<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('retailSale.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('retailSale.pageTitle'), href: '/retail-sales' },
          { text: $t('edit'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('retailSale.actionForm') }}</legend>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-form-label col-md-2">{{
                                $t('retailSale.student')
                              }}</label>
                              <div class="col-md-6">
                                <a-select
                                  v-model="model.student_id"
                                  show-search
                                  :placeholder="$t('search')"
                                  style="width: 100%"
                                  :default-active-first-option="false"
                                  :show-arrow="false"
                                  :filter-option="false"
                                  :not-found-content="null"
                                  :loading="fetching_student"
                                  @search="handleSearchStudent"
                                  @change="onStudentChange"
                                >
                                  <a-select-option
                                    v-for="student in studentResources"
                                    :key="student.student_id"
                                  >
                                    {{
                                      student.full_name_en +
                                      ' (' +
                                      student.gender +
                                      ')'
                                    }}
                                  </a-select-option>
                                </a-select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-form-label col-md-2 required">{{
                                $t('retailSale.date')
                              }}</label>
                              <div class="col-md-6">
                                <a-date-picker
                                  v-model="model.stock_out_date"
                                  format="DD-MM-YYYY"
                                  valueFormat="DD-MM-YYYY"
                                  :placeholder="$t('selectDate')"
                                  style="width: 100%"
                                />
                                <div
                                  class="validate"
                                  v-if="errors.has('stock_out_date')"
                                >
                                  {{ errors.first('stock_out_date') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-form-label col-md-2">{{
                                $t('retailSale.remark')
                              }}</label>
                              <div class="col-md-6">
                                <textarea
                                  v-model.trim="model.remarks"
                                  rows="3"
                                  class="form-control"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 ts-space-y-3">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-form-label col-md-2">{{
                                $t('invoice.paymentMethod')
                              }}</label>
                              <div class="col-md-6">
                                <select
                                  class="form-control"
                                  v-model="model.payment_method_id"
                                  @change="onPaymentMethodChange"
                                >
                                  <option
                                    v-for="(p, index) in paymentMethods"
                                    :key="index"
                                    :value="p.id"
                                  >
                                    {{ p.label }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label
                                class="col-form-label col-md-2"
                                :class="
                                  model.payment_method_id == 1 ? '' : 'required'
                                "
                                >{{ $t('invoice.bankName') }}</label
                              >
                              <div class="col-md-6">
                                <select
                                  v-model="model.bank_id"
                                  class="form-control"
                                  :disabled="model.payment_method_id == 1"
                                  @change="onBankProfileChange"
                                >
                                  <option
                                    v-for="(b, index) in bankProfiles"
                                    :value="b.bank_id"
                                    :key="index"
                                  >
                                    {{ b.bank_name }}
                                  </option>
                                </select>
                                <div
                                  class="validate"
                                  v-if="errors.has('bank_id')"
                                >
                                  {{ errors.first('bank_id') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label
                                class="col-form-label col-md-2"
                                :class="
                                  model.payment_method_id == 1 ? '' : 'required'
                                "
                                >{{ $t('invoice.bankAccount') }}</label
                              >
                              <div class="col-md-6">
                                <select
                                  v-model="model.account_id"
                                  class="form-control"
                                  :disabled="model.payment_method_id == 1"
                                >
                                  <option
                                    v-for="(b, index) in bankAccounts"
                                    :value="b.account_id"
                                    :key="index"
                                  >
                                    {{ b.account_number }} |
                                    {{ b.account_name }}
                                  </option>
                                </select>
                                <div
                                  class="validate"
                                  v-if="errors.has('account_id')"
                                >
                                  {{ errors.first('account_id') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <panel :title="$t('retailSale.item')">
                        <item-detail v-model="model" :validate="errors" />
                        <div class="validate" v-if="errors.has('detail_list')">
                          {{ errors.first('detail_list') }}
                        </div>
                        <div class="row mt-2">
                          <div class="col-md-12 text-right">
                            <ts-button
                              class="mr-2"
                              @click.prevent="
                                $router.push({ name: 'retail-sale' })
                              "
                              >{{ $t('cancel') }}</ts-button
                            >
                            <ts-button
                              class="ml-2"
                              color="primary"
                              :waiting="waiting"
                              @click.prevent="updateData"
                              >{{ $t('update') }}</ts-button
                            >
                          </div>
                        </div>
                      </panel>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import moment from 'moment'
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ItemDetail from './components/item-detail'

export default {
  name: 'retailSaleEdit',
  components: {
    ItemDetail
  },
  data () {
    this.handleSearchStudent = debounce(this.handleSearchStudent, 800)
    return {
      waiting: false,
      model: {
        stock_out_id: null,
        stock_out_date: moment().format('DD-MM-YYYY'),
        payment_method_id: 1,
        bank_id: null,
        account_id: null,
        student_id: null,
        remarks: null,
        detail_list: []
      },
      bank: [],
      bankAccount: [],
      studentResources: [],
      fetching_student: false,
      errors: new Errors()
    }
  },
  async created () {
    await this.getBankProfile()
    await this.setEditData()
    await this.onBankProfileChange()
  },
  computed: {
    ...mapState('retailSale', ['edit_data']),
    paymentMethods () {
      return [
        { id: 1, label: 'Cash' },
        { id: 2, label: 'Cheque' },
        { id: 3, label: 'Bank Transfer' },
        { id: 4, label: 'Credit Card' }
      ]
    },
    bankProfiles () {
      return this.bank
    },
    bankAccounts () {
      return this.bankAccount
    }
  },
  methods: {
    ...mapActions('retailSale', ['searchingStudent', 'update', 'bankProfile']),
    updateData () {
      this.errors = new Errors()
      this.waiting = true
      this.update({
        id: this.model.stock_out_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$router.push({ name: 'retail-sale' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async getBankProfile () {
      await this.bankProfile()
        .then(response => {
          this.bank = response.data
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onStudentChange () {
      this.model.bank_id = null
      this.bankStudent(this.model.student_id).then(response => {
        let bank = response.data
        if (bank) {
          this.model.bank_id = bank.bank_id
          this.onBankProfileChange()
          this.model.account_id = bank.account_id
        }
      })
    },
    onPaymentMethodChange () {
      if (this.model.payment_method_id == 1) {
        this.model.bank_id = null
        this.model.account_id = null
      }
      // else {
      //   if (this.bank) {
      //     var b = this.bank.find(b => parseInt(b.is_default) == 1)
      //     this.model.bank_id = b.bank_id
      //   }
      // }
    },
    onBankProfileChange () {
      var b = this.bank.find(b => b.bank_id == this.model.bank_id)
      if (b) {
        this.bankAccount = b.bank_accounts
      }
    },
    handleSearchStudent (value) {
      this.studentResources = []
      this.fetching_student = true
      this.searchingStudent({
        search: value,
        fields: {
          setup_student_profiles: 'student_id,first_name_en,last_name_en,gender'
        },
        page: -1
      })
        .then(response => {
          this.studentResources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_student = false
        })
    },
    setEditData () {
      this.model.stock_out_id = this.edit_data.stock_out_id
      this.model.payment_method_id = this.edit_data.payment_method_id
      this.model.bank_id = this.edit_data.bank_account
        ? this.edit_data.bank_account.bank_id
        : null
      this.model.account_id = this.edit_data.account_id
      if (this.edit_data.student) {
        this.studentResources.push(this.edit_data.student)
      }
    },
    clearInput () {
      ;(this.model.stock_out_date = moment().format('DD-MM-YYYY')),
        (this.model.student_id = null),
        (this.model.remarks = null),
        (this.model.detail_list = [])
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('retailSale/SET_EDIT_DATA', [])
    next()
  }
}
</script>

<style lang="css" scoped>
.panel {
  margin-bottom: 0 !important;
}
</style>
